import { cn } from "@kyan/ui";

interface PositionIndicatorProps {
  variant: "long" | "short";
}

export const PositionIndicator: React.FC<PositionIndicatorProps> = ({
  variant,
}) => {
  const isLong = variant === "long";

  return (
    <div
      className={cn("flex size-4 items-center justify-center rounded-xs", {
        "bg-success/15": isLong,
        "bg-error/15": !isLong,
      })}
    >
      <div
        className={cn("size-1.5 rounded-full", {
          "bg-success": isLong,
          "bg-error": !isLong,
        })}
      />
    </div>
  );
};
